// AboutUs.js
import React from 'react';
import Footer from './components/Footer';
import Header from './components/Header';
import './Help.css';

const AboutUs = () => {
  return (
    <div className="App">
      <Header />
      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '20px' }} className='help-content'>
        <h1>FAQs</h1>
        <div style={{ marginTop: '0px', fontSize: "14px" }}>
          <h3>Why can't I add my property?</h3>
          <p>Currently, Domogogo only supports adding properties that are listed on Rightmove.</p><br/>

          <h3>How do I add a property via Rightmove?</h3>
          <p>In order to add a property you need to get the link from the address bar. The link will look something like this:<br/>
          <span style={{fontSize:"14px", overflowWrap: "break-word"}}>https://www.rightmove.co.uk/properties/123456789#/?channel=RES_BUY</span>
          </p><br/>

          <h3>How do I copy links on mobile?</h3>
          <p>If you are struggling on mobile, go to the proprty on rightmove and follow these steps:<br/>
          <img alt='how-to-add-links' className='help-image' src='./imgs/how-to-copy-links.png' style={{paddingTop:'10px'}}/>
          </p><br/>

          <h3>How come the property details have changed on Rightmove but they haven't updated in here?</h3>
          <p>When you add a property onto Housefinder it is a snapshot in time, if you want the latest details remove and re-add the property.</p><br/>

          <h3>Where are all of your cool icons from?</h3>
          <p>Great question! Here: <a href="https://www.flaticon.com/free-icons/car-parking" title="car parking icons">Car parking icons created by Freepik - Flaticon</a></p><br/>

          <h3>Who can I contact if I have a problem?</h3>
          <p>The best place to go is to our <a href='./contact-us'>contact page</a>, however you can email us directly at hello@domogogo.com</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
